import React from "react";
import { Col, Form, Spinner } from "react-bootstrap";

export interface SelectFieldProps<T> {
  label: string;
  value: string | number | null | undefined;
  options: T[];
  getOptionValue: (item: T) => string;
  getOptionLabel: (item: T) => string;
  colSize?: number;
  isEditable?: boolean;
  isDisabled?: boolean;
  onChange?: (value: string) => void;
  isLoading?: boolean;
  placeholder?: string;
  labelExtra?: React.ReactNode;
}

export function SelectField<T>({
  label,
  value,
  options,
  getOptionValue,
  getOptionLabel,
  colSize = 4,
  isEditable = false,
  isDisabled = false,
  onChange,
  isLoading = false,
  placeholder,
  labelExtra,
}: SelectFieldProps<T>) {
  return (
    <Col xs={12} md={colSize}>
      <Form.Group className="mb-3">
        <Form.Label>
          {label} {labelExtra}
          {isLoading && <Spinner variant="primary" size="sm" className="ms-2" />}
        </Form.Label>
        {isEditable ? (
          <Form.Select
            aria-label={label}
            value={value || ""}
            onChange={(e) => onChange?.(e.target.value)}
            disabled={isDisabled}
          >
            {placeholder && <option value="">{placeholder}</option>}
            {options.map((item) => (
              <option key={getOptionValue(item)} value={getOptionValue(item)}>
                {getOptionLabel(item)}
              </option>
            ))}
          </Form.Select>
        ) : (
          <Form.Control type="text" value={value || ""} readOnly disabled />
        )}
      </Form.Group>
    </Col>
  );
}

export default SelectField;
